module.exports = __webpack_public_path__ + "static/media/chenyihan.752660f9.png";